import { render, staticRenderFns } from "./TarjaView.vue?vue&type=template&id=433476c4&scoped=true"
import script from "./TarjaView.vue?vue&type=script&lang=js"
export * from "./TarjaView.vue?vue&type=script&lang=js"
import style0 from "./TarjaView.vue?vue&type=style&index=0&id=433476c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433476c4",
  null
  
)

export default component.exports